import { LoadingAnimation } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import React from "react";

import { useParams } from "react-router-dom";
import { ReactComponent as InvoiceFilled } from "./assets/invoice-filled.svg";
import { ReactComponent as BillFromFilled } from "./assets/bill-from-filled.svg";
import { ReactComponent as BillToFilled } from "./assets/bill-to-filled.svg";
import { ReactComponent as ItemFilled } from "./assets/item-filled.svg";
import { ReactComponent as AdditionalNoteFilled } from "./assets/additional-note-filled.svg";
import { InvoiceForm } from "./components/InvoiceForm";
import { InvoicesItemFormPageProvider } from "./context/InvoicesItemFormPageProvider";
import { BillToForm } from "./components/BillToForm";
import { ItemsForm } from "./components/ItemsForm/ItemsForm";
import { AdditionalNoteForm } from "./components/AdditionalNoteForm";
import { BillFromField } from "./components/InvoiceForm/components/BillFromField";
import { InvoicesItemHeader } from "./components/InvoicesItemHeader/InvoicesItemHeader";
import { InvoiceTile } from "./components/InvoiceTile/InvoiceTile";
import { InvoiceItemFormButtons } from "./components/InvoiceItemFormButtons";
import { useInvoicesConfigList } from "../InvoicesSettingsPage/pages/InvoicesBusinessInformationPage/hooks/useInvoicesConfigList";

export const InvoicesItemFormPage: React.FC = () => {
  const { t } = useTranslations();
  const { isLoading } = useInvoicesConfigList();

  const { id: invoiceId } = useParams();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <LoadingAnimation size="xl" />
      </div>
    );
  }

  return (
    <InvoicesItemFormPageProvider id={invoiceId}>
      <div className="flex h-full w-full flex-col overflow-hidden">
        <InvoicesItemHeader id={invoiceId} />

        <div className="jugl__custom-scrollbar grow space-y-4 overflow-auto bg-dark-100 px-8 py-6">
          <InvoiceTile
            icon={<InvoiceFilled />}
            title={t({
              id: "invoices.item.details",
              defaultMessage: "Details",
            })}
          >
            <InvoiceForm />
          </InvoiceTile>

          <InvoiceTile
            icon={<BillFromFilled />}
            title={t({
              id: "invoices.item.billFrom",
              defaultMessage: "Bill from",
            })}
          >
            <BillFromField />
          </InvoiceTile>

          <InvoiceTile
            icon={<BillToFilled />}
            title={t({
              id: "invoices.item.billTo",
              defaultMessage: "Bill to",
            })}
          >
            <BillToForm />
          </InvoiceTile>

          <InvoiceTile
            icon={<ItemFilled />}
            title={t({
              id: "invoices.item.items-services",
              defaultMessage: "Items/Services",
            })}
          >
            <ItemsForm />
          </InvoiceTile>

          <InvoiceTile
            icon={<AdditionalNoteFilled />}
            title={t({
              id: "invoices.item.additionalNotes",
              defaultMessage: "Additional notes",
            })}
          >
            <AdditionalNoteForm />
          </InvoiceTile>
        </div>

        <InvoiceItemFormButtons />
      </div>
    </InvoicesItemFormPageProvider>
  );
};
